<template>
    <div>
        <!-- Vişne fabrika çıkış tonajı: değiştirilemez, referans olarak gösterilir.
             Kullanıcı karşı tarafın (nakliyecinin) beyanını "Karşı Tonaj" alanına girer.
             Karşı tonaj boş kalırsa fiyat hesabı Vişne değerini kullanır. -->
        <div class="row">
            <div class="col-12 mb-1">
                <label class="form-label text-muted">Vişne Tonajı (fabrika çıkış — değişmez)</label>
                <input type="text" class="form-control" :value="value.VisneTonnageStr" disabled />
            </div>
            <div class="col-12 mb-1">
                <label class="form-label">
                    Karşı Tonaj (nakliyeci beyanı)
                    <small class="text-muted ml-50">boş bırakılırsa Vişne değeri geçerli sayılır</small>
                </label>
                <input type="text" class="form-control"
                       v-model="value.Tonnage"
                       placeholder="Örn: 24,5 — boş bırakılabilir" />
            </div>
            <!-- Kullanıcı görsel olarak farkı görsün. -->
            <div class="col-12" v-if="fark !== null">
                <div class="alert" :class="fark === 0 ? 'alert-secondary' : 'alert-warning'">
                    <small>
                        Fark: <strong>{{ farkStr }}</strong> ton
                        <span v-if="fark > 0">(karşı taraf {{ Math.abs(fark).toFixed(2) }} ton fazla beyan etti)</span>
                        <span v-else-if="fark < 0">(karşı taraf {{ Math.abs(fark).toFixed(2) }} ton eksik beyan etti)</span>
                        <span v-else>(aynı)</span>
                    </small>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        value:Object
    },
    computed:{
        // Vişne fabrika çıkış tonajı (numerik) — value.VisneTonnage veya
        // string'i (VisneTonnageStr) üzerinden okuyoruz.
        visneNum(){
            if(this.value?.VisneTonnage != null) return Number(this.value.VisneTonnage)
            const s = this.value?.VisneTonnageStr
            if(!s) return null
            const n = Number(String(s).replace(/\./g,'').replace(',','.'))
            return isNaN(n) ? null : n
        },
        // Kullanıcının girdiği karşı tonaj (numerik). Boş ise null.
        counterNum(){
            const s = this.value?.Tonnage
            if(s == null || s === '') return null
            const n = Number(String(s).replace(/\./g,'').replace(',','.'))
            return isNaN(n) ? null : n
        },
        fark(){
            if(this.counterNum == null || this.visneNum == null) return null
            return Number((this.counterNum - this.visneNum).toFixed(4))
        },
        farkStr(){
            if(this.fark == null) return ''
            const sign = this.fark > 0 ? '+' : (this.fark < 0 ? '' : '±')
            return `${sign}${this.fark.toFixed(2)}`
        }
    }
}
</script>

<style>

</style>
